export const speak = (text, voice = null, onStart = () => {}, onEnd = () => {}) => {
    const synth = window.speechSynthesis;
    if (!synth) return;

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = 'en-US';
    utterance.rate = 1; // adjust speed if needed

    if (voice) {
        utterance.voice = voice;
    }

    utterance.onstart = onStart;
    utterance.onend = onEnd;
    synth.speak(utterance);
};

